import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";

export interface IHelperBox {
  icon: string;
  heading: string;
  description: string;
}

const HelperBox = ({ icon, heading, description }: IHelperBox) => (
  <Stack
    sx={{ backgroundColor: colors.gray10 }}
    padding={3}
    borderRadius={3}
    gap={3}
    flexDirection="row"
  >
    <img src={icon} width="70px" height="100px" alt="" />
    <Stack gap={1}>
      <Text variant="h3">{heading}</Text>
      <Text variant="text2">{description}</Text>
    </Stack>
  </Stack>
);

export default HelperBox;
